import { SHORT_DATE_FORMAT } from '@/shared/config';

export const SESSION_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  ...SHORT_DATE_FORMAT,
  hour: '2-digit',
  minute: '2-digit',
};

// Order matters: a user agent often matches several patterns, and the first
// match wins.
export const BROWSER_PATTERNS: ReadonlyArray<{
  name: string;
  pattern: RegExp;
}> = [
  { name: 'Edge', pattern: /Edg(A|iOS)?\// },
  { name: 'Opera', pattern: /OPR\// },
  { name: 'Firefox', pattern: /(Firefox|FxiOS)\// },
  { name: 'Chrome', pattern: /(Chrome|CriOS)\// },
  { name: 'Safari', pattern: /Safari\// },
];

export const OS_PATTERNS: ReadonlyArray<{ name: string; pattern: RegExp }> = [
  { name: 'iOS', pattern: /iPhone|iPad|iPod/ },
  { name: 'Android', pattern: /Android/ },
  { name: 'Windows', pattern: /Windows/ },
  { name: 'macOS', pattern: /Mac OS X|Macintosh/ },
  { name: 'Linux', pattern: /Linux/ },
];
